import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';


@Component({
  selector: 'demo-cif-creation',
  templateUrl: './demo-cif-creation.html'
})
export class DemoCifCreation implements OnInit {
  cifCreatedFlag: boolean = false;
  hideCifScreen: boolean = false;
  flowType: any;
  preQualObj: any;

  constructor(private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
    if (sessionStorage.getItem("flow_type")) {
      this.flowType = JSON.parse(sessionStorage.getItem("flow_type"));
    }
    console.log("flow type print", this.flowType);
  }

  ngOnInit(): void {
    console.log("initialized");
    this.preQualObj = this.utilService.getSessionStorage();
  }

  cifCreated(status) {
    this.hideCifScreen = true;
    if (status === 'failed') {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    } else {
      this.cifCreatedFlag = true;
    }
  }

  dmResponse(status) {
    const newObj = {
      "preQualify_mortgage_amount": 0,
      "preQualify_purchase_price": 0,
      "preQualify_mortgage_reference_number": "9100000969",
      "cmhc_default_insurance": 0,
      "total_mortgage_amount": 0,
      "down_payment": 0,
      "CBScore": 0,
    }
    this.preQualObj = {
      ...this.preQualObj, ...newObj
    }
    console.log(this.preQualObj, "prequalObj in dmResponse");
    this.utilService.getDMRespone(this.preQualObj).subscribe((response: any) => {
      console.log("response from DM =>", response);
      this.utilService.setSessionStorage(response);
      setTimeout(() => {
        if (status === 'failed') {
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        } else {
          if (this.flowType != null && this.flowType?.type === 'S') {
            this.router.navigate(['../mortgage-detail'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          } else {
            this.router.navigate(['../summary'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
        }
      })

    })

  }

}


